import { NgIf } from '@angular/common';
import { Directive, OnDestroy, OnInit } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { Subscription } from 'rxjs';
import { Customer } from '@df/session/api/customer';

/**
 * Use this directive to present element only in user is logged in
 *
 * ```html
 * <div *ifLoggedIn>...</div>
 * ```
 */
// @Directive({
//     selector: '[ifLoggedIn]'
// })
@Directive()
export abstract class IfLoggedInDirectiveDef extends NgIf implements OnInit, OnDestroy {
    protected subscriptions = new Subscription();

    @NgInject(Customer)
    readonly customer!: Customer;

    /**
     * Subscribes to customer changes and runs initial check
     *
     * @memberof IfDevDirective
     */
    ngOnInit() {
        this.subscriptions.add(this.customer.model.obs.status.subscribe(() => this.update()));
        this.update();
    }

    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }

    /**
     * Updates condition
     */
    protected update() {
        this.ngIf = this.customer.model.isLoggedIn;
    }
}
